import _ from 'lodash'

export const handleGetDocumentData = (state, { payload }) => {
  state.data = payload.data

  const documentList = _.get(payload, 'data.documentList', [])
  const courseUuid = _.get(payload, 'data.course.uuid', '')
  const trainingPlanUuid = _.get(payload, 'data.trainingPlan.uuid', '')
  const callbackUrl = `/course/${courseUuid}/class/${trainingPlanUuid}`
  state.isResend = _.get(payload, 'data.round', 1) > 1

  const newList = documentList
    .map((item, index) => ({ ...item, key: index }))
    .filter((item) => item.allow)

  // ✅ merge กับ requestData เดิม (รักษา fileName, file, displayName)
  const mergedList = newList.map((item) => {
    const oldItem = state.requestData?.find((old) => old.key === item.key) || {}
    return {
      ...item,
      fileName: oldItem.fileName,
      file: oldItem.file,
      displayName: oldItem.displayName,
    }
  })

  state.requestData = mergedList
  state.callbackUrl = callbackUrl
}

export const handleServiceError = (state, { meta }) => {
  if (meta.response.status < 500) state.error = meta.response?.data
}
